export const rowsPerPageOptionsValues = [2, 5, 10, 20, 50, 100];

export const addStylesForPinnedColumns = (
  checkboxSelectionTurnedOn: boolean,
  cellsWidth: number[],
  leftPinndedColumnsCount: number,
  rightPinnedColumnsCount: number,
  pinnEditColumn: boolean,
  tableWidth: number
): any => {
  const styleWidthForLeftPinned = checkboxSelectionTurnedOn
    ? cellsWidth.slice(0, leftPinndedColumnsCount + 1)
    : cellsWidth.slice(0, leftPinndedColumnsCount);

  const styleWidthForRightPinned: { [key: number]: number }[] = [];

  const pinnedRightStartsWithIdx = pinnEditColumn
    ? cellsWidth.length - rightPinnedColumnsCount - 1
    : cellsWidth.length - rightPinnedColumnsCount;

  for (let i = pinnedRightStartsWithIdx; i < cellsWidth.length; i++) {
    if (i + 1 === cellsWidth.length) {
      styleWidthForRightPinned.push({ [i]: 0 });
    } else {
      const right = cellsWidth.slice(i + 1, cellsWidth.length).reduce((acc, curr) => acc + curr, 0);

      styleWidthForRightPinned.push({ [i]: right });
    }
  }

  const styleWidthForHeaderRightPinned: { [key: number]: number }[] = [];

  for (let i = pinnedRightStartsWithIdx; i < cellsWidth.length; i++) {
    const left = tableWidth - cellsWidth.slice(i, cellsWidth.length).reduce((acc, curr) => acc + curr, 0);

    styleWidthForHeaderRightPinned.push({ [i]: left });
  }

  return {
    '& [class*="MuiDataGrid-columnHeaderRow"]': {
      ...styleWidthForLeftPinned
        .map((width, idx) => {
          const marginLeft = idx === 0 ? 0 : styleWidthForLeftPinned.slice(0, idx).reduce((acc, curr) => acc + curr, 0);

          return {
            [`&>div:nth-child(${idx + 1})`]: {
              position: "sticky",
              left: `${marginLeft}px`,
            },
          };
        })
        .reduce((acc, obj) => {
          return { ...acc, ...obj };
        }, {}),

      ...styleWidthForHeaderRightPinned
        .map((item) => {
          const key = Number(Object.keys(item)[0]);

          return {
            [`&>div:nth-child(${key + 1})`]: {
              position: "absolute",
              left: `${item[key]}px`,
              background: "#f5f5f5",
              zIndex: "100 !important",
            },
          };
        })
        .reduce((acc, obj) => {
          return { ...acc, ...obj };
        }, {}),
    },

    "& .MuiDataGrid-row": {
      ...styleWidthForLeftPinned
        .map((width, idx) => {
          const marginLeft = idx === 0 ? 0 : styleWidthForLeftPinned.slice(0, idx).reduce((acc, curr) => acc + curr, 0);

          return {
            [`&>div:nth-child(${idx + 1})`]: {
              position: "sticky !important",
              left: `${marginLeft}px !important`,
              background: "white",
              zIndex: 100,
            },
          };
        })
        .reduce((acc, obj) => {
          return { ...acc, ...obj };
        }, {}),

      ...styleWidthForLeftPinned
        .map((width, idx) => {
          return {
            [`&:hover>div:nth-child(${idx + 1})`]: {
              background: "#F5F5F5",
            },
          };
        })
        .reduce((acc, obj) => {
          return { ...acc, ...obj };
        }, {}),

      ...styleWidthForRightPinned
        .map((item, idx) => {
          const key = Number(Object.keys(item)[0]);

          return {
            [`&>div:nth-child(${key + 1})`]: {
              position: "sticky !important",
              right: `${item[key]}px !important`,
              background: "white",
              zIndex: 100,
            },
          };
        })
        .reduce((acc, obj) => {
          return { ...acc, ...obj };
        }, {}),

      ...styleWidthForRightPinned
        .map((item, idx) => {
          const key = Number(Object.keys(item)[0]);
          return {
            [`&:hover>div:nth-child(${key + 1})`]: {
              background: "#F5F5F5",
            },
          };
        })
        .reduce((acc, obj) => {
          return { ...acc, ...obj };
        }, {}),
    },
  };
};

export const addStylesForHeaderPinnedColumns = (
  checkboxSelectionTurnedOn: boolean,
  cellsWidth: number[],
  leftPinndedColumnsCount: number,
  rightPinnedColumnsCount: number,
  currentTransform: any,
  pinnEditColumn: boolean,
  tableWidth: number
): any => {
  const styleWidthForLeftPinned = checkboxSelectionTurnedOn
    ? cellsWidth.slice(0, leftPinndedColumnsCount + 1)
    : cellsWidth.slice(0, leftPinndedColumnsCount);

  const match = currentTransform.match(/translate3d\(([-0-9.]+)px/);
  const currentTranslateX = match ? parseFloat(match[1]) : 0;

  // Calculate the adjustment needed to compensate for the translation
  const adjustment = -currentTranslateX;

  const styleWidthForRightPinned: { [key: number]: number }[] = [];

  const pinnedRightStartsWithIdx = pinnEditColumn
    ? cellsWidth.length - rightPinnedColumnsCount - 1
    : cellsWidth.length - rightPinnedColumnsCount;

  for (let i = pinnedRightStartsWithIdx; i < cellsWidth.length; i++) {
    const left =
      adjustment + (tableWidth - cellsWidth.slice(i, cellsWidth.length).reduce((acc, curr) => acc + curr, 0));

    styleWidthForRightPinned.push({ [i]: left });
  }

  return {
    '& [class*="MuiDataGrid-columnHeaderRow"]': {
      ...styleWidthForLeftPinned
        .map((width, idx) => {
          const marginLeft =
            idx === 0
              ? adjustment + 0
              : adjustment + styleWidthForLeftPinned.slice(0, idx).reduce((acc, curr) => acc + curr, 0);
          return {
            [`&>div:nth-child(${idx + 1})`]: {
              position: "sticky !important",
              left: `${marginLeft}px !important`,
              background: "#f5f5f5",
              zIndex: "100 !important",
            },
          };
        })
        .reduce((acc, obj) => {
          return { ...acc, ...obj };
        }, {}),

      ...styleWidthForRightPinned
        .map((item) => {
          const key = Number(Object.keys(item)[0]);

          return {
            [`&>div:nth-child(${key + 1})`]: {
              position: "absolute !important",
              left: `${item[key]}px`,
              background: "#f5f5f5",
              zIndex: "100 !important",
            },
          };
        })
        .reduce((acc, obj) => {
          return { ...acc, ...obj };
        }, {}),
    },
  };
};
